<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog title="班级成绩" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1100px">
            <span>
                <el-form v-loading="loading">
                    <div style="width: 100%" class="grade_dialog el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body simple-table">
                                <tbody>
                                    <tr>
                                        <td class="el-table__cell tdcont" :colspan="colspan">
                                            <div class="title">
                                                <span>茂 名 技 师 学 院</span>
                                                <span class="year">{{ row.schoolYear || '-' }}</span>
                                                <span>学年第</span>
                                                <span class="times">{{ row.semester || '-' }}</span>
                                                <span>学期成绩汇总表（考核）</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdcont" :colspan="colspan">
                                            <div class="title_mid">
                                                <div>班别：{{ row.className }}</div>
                                                <div>班主任：{{ row.teacherName || row.passenger.teacherName || '-' }}</div>
                                                <div>审核：</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <template v-if="gradeDataList.length">
                                        <tr>
                                            <td class="el-table__cell tdcont" colspan="2" style="padding: 0">
                                                <canvas id="myCanvas" style="width: 100%; height: 100%; padding-top: 8px" />
                                            </td>
                                            <td v-for="(item, index) in gradeDataList[0].list" :key="index" class="el-table__cell tdcont" colspan="2">
                                                <div class="lh18">
                                                    {{ item.courseName }}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-for="(item, index) in gradeDataList" :key="index">
                                            <td class="el-table__cell tdcont tdc" colspan="1">
                                                <div>{{ index + 1 }}</div>
                                            </td>
                                            <td class="el-table__cell tdcont tdc" colspan="1">
                                                <div class="lh18">{{ item.name }}</div>
                                            </td>
                                            <td v-for="(grade, it) in item.list" :key="it" class="el-table__cell tdcont" colspan="2">
                                                <div>{{ grade.score }}</div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td class="el-table__cell tdcont" :colspan="colspan">
                                                <div style="height: 40px; line-height: 40px">暂无数据</div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button :loading="doing" type="primary" @click="exportClick">导 出</el-button>
                <!-- <el-button type="primary" @click="confirmClick">确 定</el-button> -->
            </span>
        </el-dialog>
        <DoingDialog />
    </div>
</template>

<script>
const qs = require('qs')
export default {
    data() {
        return {
            dialogVisible: false,
            loginUser: this.$store.getters.loginUser,
            doing: false,
            row: {
                passenger: {}
            },
            colspan: 0,
            headers: ['科目', '成绩', '姓名'],
            gradeDataList: [],
            loading: false,
            formType: ''
        }
    },
    created() {
        this.$bus.on('openGradeDataTable', this.openGradeDataTable)
        this.$bus.on('exportGradeDataTable', this.exportGradeDataTable)
    },
    beforeDestroy() {
        this.$bus.off('openGradeDataTable', this.openGradeDataTable)
        this.$bus.off('exportGradeDataTable', this.exportGradeDataTable)
    },
    methods: {
        openGradeDataTable(row, type) {
            this.row = row
            this.formType = type
            this.gradeDataList = []
            this.colspan = 0
            this.initData()
            this.dialogVisible = true
        },
        async initData(row = null, type = null) {
            this.loading = true
            if (row) this.row = row
            if (type) this.formType = type

            let rest = await this.getStudentBasicInfo()

            if (rest.code === 'success') {
                const list = rest.body.list
                if (list.length > 0) {
                    this.gradeDataList = list
                    this.colspan = this.gradeDataList[0].list.length * 2 + 2
                    this.row.semester = this.gradeDataList[0].semester
                    this.row.year = this.gradeDataList[0].year
                } else {
                    this.gradeDataList = []
                    this.colspan = 0
                    // this.row = {passenger: {}}
                }
            } else {
                this.gradeDataList = []
                this.colspan = 0
                // this.row = {passenger: {}}
            }
            this.loading = false
            this.$nextTick(() => {
                setTimeout(() => {
                    this.drawCanvas()
                }, 100)
            })
        },
        drawCanvas() {
            // 1. 获取 Canvas 元素和上下文
            const canvas = document.getElementById('myCanvas')
            canvas.height = 40
            const ctx = canvas.getContext('2d')

            // 2. 绘制灰色背景矩形
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, canvas.width, canvas.height) // 填充整个画布

            // 3. 绘制对角线（从左上到右下）
            ctx.beginPath()
            ctx.moveTo(0, 0) // 起点：左上角
            ctx.lineTo(canvas.width, canvas.height) // 终点：右下角
            ctx.strokeStyle = '#000' // 线条颜色
            ctx.lineWidth = 1 // 线条粗细
            ctx.stroke()

            // 4. 绘制左侧文字（姓名）
            ctx.font = '15px Arial' // 设置字体
            ctx.fillStyle = '#000' // 文字颜色
            ctx.textAlign = 'left' // 左对齐
            ctx.fillText('姓名', 20, 40) // 文字位置 (x=20, y=40)

            ctx.font = '15px Arial' // 设置字体
            ctx.fillStyle = '#000' // 文字颜色
            ctx.textAlign = 'left' // 左对齐
            ctx.fillText('成绩', 80, 40) // 文字位置 (x=20, y=40)

            // 5. 绘制右侧文字（科目）
            ctx.textAlign = 'right' // 右对齐
            ctx.fillText('科目', canvas.width - 20, canvas.height - 20) // 右下角附近
        },
        async getStudentBasicInfo() {
            var params = {}
            if (this.formType === 'student') {
                params.studentId = this.row.studentId
            } else if (this.formType === 'class') {
                params.className = this.row.className
                params.admissionYear = this.row.admissionYear
            }
            const result = await this.$http({
                contentType: 'application/x-www-form-urlencoded',
                // url: `xsgl/studentExamScores/listExamScores`,
                url: `/xsgl/studentExamScoresLog/listExamScores`,
                method: 'POST',
                params: {
                    logId: this.row.id
                }
            })
            if (result.code === 'success') {
                return result
            }
        },
        async exportGradeDataTable(row, type) {
            this.$bus.emit('showDoingDialog')
            await this.initData(row, type)
            if (!this.gradeDataList.length) {
                this.$bus.emit('closeDoingDialog')
                this.$alert('暂无可导出的数据', '操作提示', { type: 'warning' })
                return
            }
            this.exportClick()
        },
        exportClick() {
            if (!this.gradeDataList.length) {
                this.$alert('暂无可导出的数据', '操作提示', { type: 'warning' })
                return
            }
            this.doing = true
            const tbtitle = [] // 表头
            const rows = [] // 数据集
            // 导出科目
            if (this.gradeDataList[0].list.length > 0) {
                let totalRow = [] // 总计行
                let list = this.gradeDataList[0]
                let temp = [
                    { value: '序号', width: 50, align: 'center', colspan: 1, rowspan: 1 },
                    { value: '姓名', width: 50, align: 'center', colspan: 1, rowspan: 1 }
                ]
                totalRow.push(...temp)
                list.list.forEach((item, itemIndex) => {
                    totalRow.push({ value: item.courseName, width: 50, align: 'center', colspan: 1, rowspan: 1 })
                })
                totalRow.push({ value: '名次', width: 50, align: 'center', colspan: 1, rowspan: 1 })
                rows.push(totalRow)
            }
            const colspan = rows[0].length
            // 导出的表头
            const title = [{ title: `茂名技师学院${this.row.schoolYear}学年第${this.row.semester || '-'}学期成绩汇总表（考核）`, width: 120, align: 'center', colspan: colspan, rowspan: 1 }]
            tbtitle.push(title)

            // 导出姓名 分数
            this.gradeDataList.forEach((item, listIndex) => {
                let totalRow = [] // 总计行
                var row = [] // 数据行
                let temp = [
                    { value: listIndex + 1, align: 'center', colspan: 1, rowspan: 1 },
                    { value: item.name, align: 'center', colspan: 1, rowspan: 1 }
                ]
                totalRow.push(...temp)
                item.list.forEach((item, itemIndex) => {
                    totalRow.push({ value: item.score, align: 'center', colspan: 1, rowspan: 1 })
                })
                totalRow.push({ value: listIndex + 1, align: 'center', colspan: 1, rowspan: 1 })
                rows.push(totalRow)
            })

            rows.unshift([{ value: `班别：${this.row.className || '-'} 班主任：${this.row.teacherName || this.row.passenger.teacherName || '-'} 审核：`, align: 'center', colspan: colspan, rowspan: 1 }])

            // 发起请求---固定写法
            this.$http({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                data: qs.stringify({
                    rows: JSON.stringify(rows),
                    titles: JSON.stringify(tbtitle),
                    fileName: `茂名技师学院${this.row.year || this.row.admissionYear}学年第${this.row.semester || '-'}学期成绩汇总表（考核）`
                }),
                url: 'common/exportXlsFile?httpPort=' + location.port
            }).then((res) => {
                if (res.code === 'success') {
                    var href = '/apigw/' + res.body.xlsurl
                    var tempLink = document.createElement('a') // 创建一个a标签
                    tempLink.style.display = 'none'
                    tempLink.href = encodeURI(href)
                    tempLink.setAttribute('download', '茂名技师学院2022-2023学年第二学期成绩汇总表（考核）.xls') // 给a标签添加下载属性
                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank')
                    }
                    document.body.appendChild(tempLink) // 将a标签添加到body当中
                    // console.log('tempLink==', tempLink)
                    tempLink.click() // 启动下载
                    document.body.removeChild(tempLink) // 下载完毕删除a标签
                    href = ''
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
                this.doing = false
                this.$bus.emit('closeDoingDialog')
            })
        },
        filterEducationSystem(val) {
            if (val == 1) {
                return '二'
            } else if (val == 2) {
                return '三'
            } else if (val == 3) {
                return '四'
            } else if (val == 4) {
                return '五'
            } else if (val == 5) {
                return '六'
            }
        }
    }
}
</script>

<style scoped lang="scss">
.grade_dialog {
    width: 100%;
    .title {
        font-weight: 600;
        font-size: 18px;
        text-align: center;
    }
    .title_mid {
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-weight: 600;
        font-size: 15px;
    }
    .simple-table tr td {
        height: 35px;
        text-align: center;
        line-height: 35px;
    }
}
.split-diagonal {
    width: 100%;
    height: 100%;
    position: relative;
}
.tdc {
    width: 60px;
}
.year {
    display: inline-block;
    width: 100px;
    line-height: 18px;
    border-bottom: 2px solid #000;
    text-align: center;
}
.times {
    display: inline-block;
    width: 70px;
    line-height: 18px;
    border-bottom: 2px solid #000;
    text-align: center;
}
.lh18 {
    line-height: 18px;
}
</style>
